let confirmationHandler = null;

const normalizeOptions = (options = {}) => ({
  title: String(options.title || 'Confirm action').trim(),
  message: String(options.message || '').trim(),
  confirmLabel: String(options.confirmLabel || 'Confirm').trim(),
  cancelLabel: String(options.cancelLabel || 'Cancel').trim(),
  tone: options.tone === 'danger' ? 'danger' : 'default'
});

export const registerAppConfirmationHandler = (handler) => {
  confirmationHandler = typeof handler === 'function' ? handler : null;

  return () => {
    if (confirmationHandler === handler) confirmationHandler = null;
  };
};
export const requestAppConfirmation = (options = {}) => {
  const normalized = normalizeOptions(options);

  if (confirmationHandler) {
    return confirmationHandler(normalized);
  }

  if (typeof window !== 'undefined' && typeof window.confirm === 'function') {
    return Promise.resolve(window.confirm(normalized.message || normalized.title));
  }

  return Promise.resolve(false);
};
